import "./NotificationItem.css";

import React from 'react';
import { formatDate } from '../../utils';
import { Link } from 'react-router-dom';
import classNames from "classnames";
import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import IconButton from "../common/IconButton";
import { Tooltip } from "antd";
import { green, blue, red, orange, gray } from '@ant-design/colors';
import { AppNotification } from "../../models/Notification";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { sectionLabelsSelector } from "../../slices/sectionsSlice";

const iconsMap: Record<string, IconDefinition> = {
  'html': regular('file-code'),
  'picture': regular('image'),
  'log': regular('file-lines'),
  'STARTING': regular('circle-play'),
  'RUNNING': solid('spinner'),
  'COMPLETED': regular('check-circle'),
  'ERROR': regular('circle-xmark'),
  'STOPPED': regular('circle-stop'),
  'STOPPING': regular('hand'),
}

const colorsMap: Record<string, string | undefined> = {
  'STARTING': orange.primary,
  'RUNNING': blue.primary,
  'COMPLETED': green.primary,
  'ERROR': red.primary,
  'STOPPED': gray.primary,
  'STOPPING': gray.primary,
}

export const renderNotificationMessage = (notification: AppNotification, applicationLabel?: string) => {
  // TODO handle different cases
  if (notification.type === "BDA_APP_STATUS_CHANGE") return (
    <>
      <Link to={`/bda-applications/${notification.details?.bdaId}`}>{applicationLabel || "Application"} {notification.details?.bdaId}</Link>{" "}
      status changed to: <b>{notification.details.status}</b>
    </>
  )

  return (
    <>
      New asset <b>"{notification.details?.name}"</b> has been created by{" "}
      <Link to={`/bda-applications/${notification.details?.bdaId}`}>{applicationLabel || "Application"} {notification.details?.bdaId}</Link>
    </>
  )
}

const renderNotificationIcon = (notification: AppNotification) => {
  if (notification.type === "BDA_APP_STATUS_CHANGE") return (
    <Tooltip title={notification.details?.status}>
      <FontAwesomeIcon icon={iconsMap[notification.details?.status]} color={colorsMap[notification.details?.status] || "black"} size="lg" fixedWidth />
    </Tooltip>
  )

  return (
    <Tooltip title={notification.details?.messageType}>
      <FontAwesomeIcon icon={iconsMap[notification.details?.messageType]} size="lg" fixedWidth />
    </Tooltip>
  )
}

export const renderNotificationTitle = (notification: AppNotification, applicationLabel?: string) => {
  return notification.type === "BDA_APP_STATUS_CHANGE" ? `${applicationLabel} Status Changed` : "Asset Created";
}

type Props = {
  notification: AppNotification;
  onReadNotification: React.MouseEventHandler<HTMLButtonElement>;
}

export default function NotificationItem({ notification, onReadNotification }: Props) {

  const applicationLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "applications"));

  return (
    <div className={classNames("notification-item", { new: !notification.read })}>
      <div className="pe-3">{renderNotificationIcon(notification)}</div>

      <Col>
        <small className="d-block text-muted">{formatDate(notification.timestamp, 'dd/MM/yyyy HH:mm:ss')}</small>
        <p className="m-0">{renderNotificationMessage(notification, applicationLabels.singular)}</p>
      </Col>

      {!notification.read && (
        <IconButton tooltip="Mark as read" onClick={onReadNotification}>
          <FontAwesomeIcon icon={solid('check-double')} />
        </IconButton>
      )}
    </div>
  )
}
